import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Checkbox } from 'semantic-ui-react';
import * as _ from 'lodash';
import PropTypes from 'prop-types';

import { setElementChanged } from 'State/dirtyTracking/actions';

class TrackedRadioContainer extends Component {
  componentDidMount() {
    this.id = this.props.groupName;
  }

  onClick = (e, data) => {
    this.props.setElementChanged(
      this.id,
      this.props.initialValue,
      this.props.value
    );
  };

  render() {
    const rest = _.omit(this.props, [
      'initialValue',
      'setElementChanged',
      'groupName',
    ]);

    return (
      <Checkbox
        radio
        name={this.props.groupName}
        {...rest}
        onClick={this.onClick}
      />
    );
  }
}

TrackedRadioContainer.propTypes = {
  groupName: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  initialValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
};

const TrackedRadio = connect(null, {
  setElementChanged,
})(TrackedRadioContainer);

export { TrackedRadio };



// WEBPACK FOOTER //
// ./src/components/tracked/TrackedRadio.js